export const SURVEY_NAME_COMPANY = "SURVEY_NAME_COMPANY";
export const SURVEY_NAME = "SURVEY_NAME";
export const SURVEY_EMAIL = "SURVEY_EMAIL";
export const SURVEY_PHONE = "SURVEY_PHONE";
export const SURVEY_STATE = "SURVEY_STATE";
export const SURVEY_SELECT = "SURVEY_SELECT";
export const SURVEY_DATA = "SURVEY_DATA";